module.exports = "/*\r\n.navbar.navbar-toggleable-md li.nav-item {\r\n  margin-right: 0px !important;\r\n}\r\n*/\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = ./src/app/app.component.css
// module chunks = main